(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypes', [ContentTypesDirective])
		.controller('ContentTypesController',
		[
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbContentTypesDataStore',
			'smbIconTypes',
			ContentTypesController
		]);

	var templateUrl = require('./contentTypes.template');
	function ContentTypesDirective() {
		return {
			restrict: 'E',
			controller: ContentTypesController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				groupId: '@'
			},
			scope: {}
		};
	}

	function ContentTypesController(gettextCatalog, pxProgressService, smbToolbarService, smbContentTypesDataStore, smbIconTypes) {
		smbToolbarService.set(gettextCatalog.getString('Document Types'), 'import.contentTypeGroups');

		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.contentTypesDataStore = smbContentTypesDataStore;

		smbContentTypesDataStore.getContentTypes(vm.groupId);
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypes/contentTypes.js
// module id = 75
// module chunks = 1